import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ManageBalances from './finances/ManageBalances';
import Deposit from './finances/Deposit';
import Withdrawals from './finances/Withdrawals';
import UserTips from './finances/UserTips';
import UserStatistics from './finances/UserStatistics';
import styles from '../userDetails.module.scss';

const UserFinances: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <ManageBalances />;
      case 1:
        return <Deposit />;
      case 2:
        return <Withdrawals />;
      case 3:
        return <UserTips />;
      case 4:
        return <UserStatistics />;
      default:
        return null;
    }
  };

  return (
    <Box className={styles.tabContent} sx={{ p: 0 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'rgba(255, 255, 255, 0.1)', mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="inherit"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              color: 'var(--text-secondary)',
              '&.Mui-selected': {
                color: 'white',
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: 'var(--accent-blue)',
            },
          }}
        >
          <Tab label="Manage balances" />
          <Tab label="Deposit" />
          <Tab label="Withdrawals" />
          <Tab label="Tips" />
          <Tab label="Statistics" />
        </Tabs>
      </Box>
      <Box sx={{ mt: 2 }}>{renderTabContent()}</Box>
    </Box>
  );
};

export default UserFinances;
